import RadioGroup from '@components/molecules/RadioGroup';
import { HouseType } from '@graphql/generated';
import {
  HouseFormResult,
  QuoteInitialForm
} from '@lib/data/typesQuestions';
import GridBox from 'components/atoms/GridBox';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface FormResult {
  houseType: HouseType;
}

interface Props {
  onSubmit: (data: HouseFormResult) => void;
  item: QuoteInitialForm;
}

const HouseTypeForm: FC<Props> = ({ onSubmit, item }) => {
  const { register, handleSubmit, errors } = useForm<FormResult>();

  return (
    <Form
      onSubmit={handleSubmit(({ houseType }) => {
        if (item.vehicle)
          onSubmit({
            vehicle: {
              ...item.vehicle,
              houseType,
            },
          });
      })}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <RadioGroup
            inputRef={register({ required: 'Escolha uma das opções' })}
            name="houseType"
            errorMessage={errors.houseType?.message}
            onSelected={(value) => {
              if (item.vehicle)
                onSubmit({
                  vehicle: {
                    ...item.vehicle,
                    houseType: value as HouseType,
                  },
                });
            }}
            options={[
              {
                label: 'Apartamento',
                value: HouseType.Apartment,
              },
              {
                label: 'Casa',
                value: HouseType.House,
              },
              {
                label: 'Casa em condomínio fechado',
                value: HouseType.Condo,
              },
              {
                label: 'Chácara, fazenda ou sítio',
                value: HouseType.Farm,
              },
              {
                label: 'Outros',
                value: HouseType.Other,
              },
            ].map((o) => {
              if (o.value === item.vehicle?.houseType)
                return { ...o, checked: true };

              return o;
            })}
          />
        </GridBox>
      </GridBox>
    </Form>
  );
};

export default HouseTypeForm;
